import React from "react";
import clsx from "clsx";
import { formatAmount } from "../../shared/helpers/formatters";
import { CURRENT_ASSET_CATS, NONCURRENT_ASSET_CATS } from "../../shared/helpers/constants";
import AFSService from "../../../../../../services/AFSService";
import "../../afs-walkthrough.css";

const fmt = formatAmount;

function SummaryView({ balanceSheet, incomeStatement, onDrillAccount, onDrillLines }) {
	const openTotal = ({ title, sections, current, prior }) => () => onDrillLines(AFSService.describeSectionsTotalToOpen({ title, sections, current, prior }));
	const assetSections = balanceSheet.sections.filter(section => CURRENT_ASSET_CATS.has(section.category) || NONCURRENT_ASSET_CATS.has(section.category));
	const liabilityAndEquitySections = balanceSheet.sections.filter(section => !assetSections.includes(section));

	const renderSection = section => (
		<div key={section.name} className="afs-summary__section">
			<div className="afs-summary__section-label">{section.name}</div>
			{section.accounts.map((account, position) => (
				<div key={position} className="afs-summary__account afs-drillable" onClick={() => onDrillAccount(account)}><span>{account.description}</span><span>{fmt(account.current)}</span></div>
			))}
			<div className="afs-summary__total afs-drillable" onClick={openTotal({ title: "Total " + section.name, sections: [section], current: section.totalCurrent, prior: section.totalPrior })}>
				<span>Total {section.name}</span><span>{fmt(section.totalCurrent)}</span>
			</div>
		</div>
	);

	return (
		<div className="afs-summary__grid">
			<div className="afs-summary__panel">
				<div className="afs-summary__panel-header">Balance Sheet</div>
				<div className="afs-summary__panel-body">
					{balanceSheet.sections.map(renderSection)}
					<div className="afs-summary__grand-total afs-drillable" onClick={openTotal({ title: "Total Assets", sections: assetSections, current: balanceSheet.totalAssets?.current, prior: balanceSheet.totalAssets?.prior })}>
						<span>Total Assets</span><span>{fmt(balanceSheet.totalAssets?.current)}</span>
					</div>
					<div className="afs-summary__grand-total afs-drillable" onClick={openTotal({ title: "Total Liabilities & Equity", sections: liabilityAndEquitySections, current: balanceSheet.totalLiabilitiesAndEquity?.current, prior: balanceSheet.totalLiabilitiesAndEquity?.prior })}>
						<span>Total Liabilities &amp; Equity</span><span>{fmt(balanceSheet.totalLiabilitiesAndEquity?.current)}</span>
					</div>
				</div>
			</div>
			<div className="afs-summary__panel">
				<div className="afs-summary__panel-header">Income Statement</div>
				<div className="afs-summary__panel-body">
					{incomeStatement.sections.map(renderSection)}
					<div
						className={clsx("afs-drillable", incomeStatement.netIncome?.current >= 0 ? "afs-summary__net-income--positive" : "afs-summary__net-income--negative")}
						onClick={openTotal({ title: "Net Income (Loss)", sections: incomeStatement.sections, current: incomeStatement.netIncome?.current, prior: incomeStatement.netIncome?.prior })}
					>
						<span>Net Income (Loss)</span><span>{fmt(incomeStatement.netIncome?.current)}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SummaryView;
